<script>

import axios from 'axios';

export default class EmpresasRepository{
    
    async getEmpresas(token,page,rawdata){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const data = rawdata;
        const response = await axios.post(baseURL, data,{headers:headers});
        return response;

    }

    async getEmpresasSelect(token,page){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers:headers});
        return response;

    }

    async createEmpresa(page,rawdata,token){
        
        console.log('entrei')
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async  deleteEmpresa(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async  getEmpresa(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async  updateEmpresa(page,token,id,rawdata) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const data = rawdata;
        const response = await axios.put(baseURL,data,{ headers });
        return response;
       
    }

    async getEmpresasAll(token,page){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers:headers});
        return response;

    }

    async importEmpresaFile(data,token,page){

        const baseURL = page;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const formData = data
        //formData.append('myFile', file);

        const response = await axios.post(baseURL, formData, { headers: headers });
        return response;

    }

    async getEmpresaQuery(token,query) {
        
        const baseURL = process.env.VUE_APP_API_URL+"empresas/autocomplete/"+`${query}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

}
</script>
